module.exports = __webpack_public_path__ + "static/img/pyt.f140bdf8.png";